"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CTRL_CHAR_CODE = 'Control';
var ALT_CHAR_CODE = 'Alt';
var META_CHAR_CODE = 'Meta';
/**
 * Returns true when the event was fired from a modifier key, otherwise false
 * @param event The keyboard event object
 */
function isModifierKey(event) {
    var isCtrlKey = event.ctrlKey || event.key === CTRL_CHAR_CODE;
    var isAltKey = event.altKey || event.key === ALT_CHAR_CODE;
    var isMetaKey = event.metaKey || event.key === META_CHAR_CODE;
    return isCtrlKey || isAltKey || isMetaKey;
}
exports.default = isModifierKey;
//# sourceMappingURL=isModifierKey.js.map